import styled from 'styled-components';

import { hex2rgb } from '@r1-frontend/shared/helpers/hex2rgb';

// @ts-ignore
import lockedIcon from '../../../assets/img/icons/locked.svg';
import { COLORS } from '../../../tokens/colors';

interface IStyleProps {
    checked?: boolean,
    disabled: boolean,
}

export const Label = styled.label<IStyleProps>`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    margin: 0;
    padding: 0;
    user-select: none;

    &:active {
        outline: none;
    }

    input[type="checkbox"] {
        appearance: none;
        position: relative;
        flex: 0 0 auto;
        width: 36px;
        height: 20px;
        margin: 0;
        padding: 0;
        background-color: ${COLORS.Disabled};
        border: none;
        border-radius: 10px;
        transition: .3s;
        overflow: hidden;
        outline: none;
        box-sizing: border-box;
        cursor: pointer;

        &:before {
            content: '';
            position: absolute;
            top: 2px;
            left: 2px;
            width: 16px;
            height: 16px;
            border-radius: 50%;
            background-color: ${COLORS.BgMain};
            transition: .3s;
        }

        @media (hover: hover) {
            &:hover,
            &:checked:hover {
                background-color: ${COLORS.Outline_Dark};

                &:before {
                    background-color: ${COLORS.Link};
                }
            }
        }

        &:required:valid {
            background-color: ${COLORS.Locked};

            &:before {
                background-color: ${COLORS.BgMain};
            }

            &:after {
                content: '';
                position: absolute;
                top: 2px;
                left: 18px;
                width: 16px;
                height: 16px;
                background-color: ${COLORS.Error};
                mask-image: url(${lockedIcon});
                mask-size: 7px 9px;
                mask-position: center;
                mask-repeat: no-repeat;
                transition: .3s;
            }
        }

        &:checked {
            background-color: ${COLORS.Control};

            &:before {
                left: 18px;
            }
        }

        &:disabled,
        &:checked:hover:disabled {
            background-color: ${COLORS.BgSecondary};
            pointer-events: none;
            
            &:before {
                background-color: rgba(${hex2rgb(COLORS.BgMain)}, 0.5);
            }
        }
    }
`;
